// Import types
import { MetadataListType } from 'types/api/products/product';

export const isNextText = (element) => element?.type === MetadataListType.Text;
